import {
  TagsPopover,
  useTagsGuard,
} from '@components/ArtBoard/Node/components/TagsPopover'
import type { ID } from '@octopus-do/octopus-project-core'
import { TinyPopover, Toolbar } from '@octopus-do/octopus-storybook'
import { Tag } from '@octopus-do/octopus-storybook/icons'
import type { AppState } from '@store/types'
import type React from 'react'
import { forwardRef } from 'react'
import { useSelector } from 'react-redux'

interface TriggerProps {
  nodeId: ID
}

const Trigger = forwardRef<HTMLButtonElement, TriggerProps>(
  ({ nodeId }, ref) => {
    const { active, toggle } = TinyPopover.useTrigger()
    useTagsGuard(nodeId, active)

    return (
      <Toolbar.DropdownButton
        active={active}
        icon={Tag}
        onClick={toggle}
        ref={ref}
        tooltip="Tags"
      />
    )
  }
)

interface Props {
  locked: boolean
  nodeId: ID
  onUpgrade: () => void
}

// The tags button of the page toolbar. A locked plan keeps the button: the
// click sells the plan instead of opening the popover. A toggled tag goes onto
// every selected page.
export const TagsMenu: React.FC<Props> = ({ locked, nodeId, onUpgrade }) => {
  const nodes = useSelector<AppState, ID[]>(
    ({ canvas }) => canvas.node.selectedNodes
  )

  if (locked) {
    return (
      <Toolbar.DropdownButton
        active={false}
        icon={Tag}
        locked
        onClick={onUpgrade}
        tooltip="Tags"
      />
    )
  }

  return (
    <TagsPopover nodeId={nodeId} nodes={nodes}>
      <Trigger nodeId={nodeId} />
    </TagsPopover>
  )
}
